import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import BET_FUNDS_INFO from './bet-funds-info.palette-schema.yaml';

registerTileSchema(BET_FUNDS_INFO);

export const BET_FUNDS_INFO_TYPES = {
    NORMAL: 'NORMAL',
    MEDIUM: 'MEDIUM',
    EMPHASIZED: 'EMPHASIZED',
};

const BET_FUNDS_INFO_TEXT_TOKENS_MAP = {
    [BET_FUNDS_INFO_TYPES.NORMAL]: 'BET_FUNDS_INFO_TEXT',
    [BET_FUNDS_INFO_TYPES.MEDIUM]: 'BET_FUNDS_INFO_MEDIUM_TEXT',
    [BET_FUNDS_INFO_TYPES.EMPHASIZED]: 'BET_FUNDS_INFO_EMPHASIZED_TEXT',
};

export function generateBetFundsInfo(TILE, TYPE = BET_FUNDS_INFO_TYPES.NORMAL) {
    const BET_FUNDS_INFO_TEXT_TILE_TOKEN =
        BET_FUNDS_INFO_TEXT_TOKENS_MAP[TYPE] || BET_FUNDS_INFO_TEXT_TOKENS_MAP[BET_FUNDS_INFO_TYPES.NORMAL];

    return {
        label: {
            style: TILE[BET_FUNDS_INFO_TEXT_TILE_TOKEN],
        },
        value: {
            style: TILE[BET_FUNDS_INFO_TEXT_TILE_TOKEN],
        },
        icon: icon(TILE.BET_FUNDS_INFO_ICON_COLOR),
    };
}
